<template>
  <!-- 图片弹框   -->
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="dialogTitle || $t('navbar.seeImage')"
    :visible.sync="dialogVisible"
    top="3vh"
    width="540px"
  >
    <div>
      <div v-if="imageList.length > 0" style="width: 500px">
        <div style="text-align: center; color: #00A551; font-size: 18px">
          <span>{{ currentIndex + 1 }}</span>
          <span>/</span>
          <span>{{ imageList.length }}</span>
        </div>
        <el-carousel
          ref="carousel" height="750px" trigger="click"
          @change="handlecarousel"
        >
          <el-carousel-item v-for="item in imageList" :key="item">
            <div style="margin-left: 10px">
              <el-image
                :preview-src-list="[item]"
                :src="item"
                fit="fill"
                style="width: 100%; height: 700px"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div v-else style="width: 500px; text-align: center; height: 750px">
        <el-image style="width: 100%">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline" style="font-size: 30px" />
          </div>
        </el-image>
      </div>
    </div>
  </el-dialog>
</template>

<script>
/**
 * 全局通用图片查看器弹窗组件
 * 支持多图轮播（高度750px）、绿色高亮计数器、点击大图放大预览以及自定义弹窗标题
 */
export default {
  name: 'ImageSeeDialog',
  data() {
    return {
      // 弹窗显隐状态
      dialogVisible: false,
      // 自定义弹窗标题（为空时默认回退至 navbar.seeImage）
      dialogTitle: '',
      // 当前待展示的图片 URL 列表
      imageList: [],
      // 当前轮播图索引
      currentIndex: 0
    };
  },
  methods: {
    /**
     * 打开图片预览弹窗
     * @param {Array<string>} arr 图片 URL 数组
     * @param {string} [title=''] 自定义弹窗标题（可选，不传默认显示系统多语言“查看图片”）
     */
    showImageFun(arr, title = '') {
      this.imageList = Array.isArray(arr) ? arr : [];
      this.dialogTitle = title || '';
      this.currentIndex = 0;
      this.dialogVisible = true;
    },
    /**
     * 轮播图切换回调
     * @param {number} val 当前切换到的图片下标
     */
    handlecarousel(val) {
      this.currentIndex = val;
    }
  }
};
</script>
<style lang="scss" scoped></style>
